module.exports = __webpack_public_path__ + "img/veri1.ebaaee5c.jpg";